import orderSlice from './orderSlice.js';
//import itemGradesCountSlice from './items-grades-counts/ItemsGradesCountSettingSlice.js';

const purchaseManagerSlices = {
    order: orderSlice
};

export default purchaseManagerSlices;